import { render, staticRenderFns } from "./form-phone-input.vue?vue&type=template&id=1d81696f"
import script from "./form-phone-input.vue?vue&type=script&lang=js"
export * from "./form-phone-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports